export default {
    syslog: {
        log_trig_setting: '日志触发设置',
        time: '时间',
        func_module: '功能模块',
        operation_time: '操作时间',
        operation: '操作',
        operator: '操作人',
        methods: '请求方式',
        content: '内容',
        param: '参数',
        result: '结果',
        operation_detail: '操作详细',

        //返回状态码
        code_0: '设置失败',
        code_1: '设置成功',
        code_other: '位置错误'
    }
};
